import { getData, postData } from '../plugins/ApiCalls'

export function fetchFormEmailSends(formId, page = 1) {
  return getData('forms/' + formId + '/email-sends', { params: { page } })
}

export function sendFormByEmail(formId, payload) {
  return postData('forms/' + formId + '/email-sends', payload)
}

export function sendFormByEmailTest(formId, payload) {
  return postData('forms/' + formId + '/email-sends/test', payload)
}

export function fetchFormEmailUsage() {
  return getData('form-email-usage')
}
